import React from 'react';
import PropTypes from 'prop-types';

const AutoInsurance = ({ className }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 114 114"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity=".2"
      d="M57 114c31.48 0 57-25.52 57-57S88.48 0 57 0 0 25.52 0 57s25.52 57 57 57z"
      fill="#B1E0E2"
    />
    <path
      d="M91.378 42.074v1.852c-4.169 41.254-29.89 50.802-33.702 51.977a1.781 1.781 0 01-.962 0c-30.708-7.588-34.021-52.796-34.378-62.415a1.747 1.747 0 011.746-1.781c19.665 0 29.034-7.838 32.062-11.186a1.676 1.676 0 012.459 0c8.728 8.728 26.22 10.367 31.635 10.687a1.746 1.746 0 011.638 1.71v2.209"
      stroke="#2061AE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M69.933 64.73a3.776 3.776 0 100-7.552 3.776 3.776 0 000 7.552zM47.88 64.876a3.776 3.776 0 100-7.553 3.776 3.776 0 000 7.553zM66.156 61.097l-14.5.107"
      stroke="#2061AE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M43.782 61.237l-5.45.25a1.354 1.354 0 01-1.354-1.034l-1.354-6.306a1.282 1.282 0 01.855-1.532l3.776-1.282c.265-.106.49-.293.642-.534l3.562-5.522a2.315 2.315 0 011.96-1.069h13.929M60.563 44.063l7.873 6.662c.37.328.828.54 1.318.606l7.73 1.104a1.675 1.675 0 011.425 1.924l-.748 5.344a1.354 1.354 0 01-1.247 1.14h-3.206M62.628 51.98l-16.423.142"
      stroke="#2061AE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

AutoInsurance.defaultProps = {
  className: '',
};

AutoInsurance.propTypes = {
  className: PropTypes.string,
};

export default AutoInsurance;
